import React, { useState } from 'react';
import { message } from 'antd';
import {
    SkillStudioAddToEvalButton,
    SkillStudioEvalGroundTruthForm,
    type SkillStudioAddToEvalMessage,
} from 'asper_design_library';
import type { AgenticChatMessage } from '../types';
import type { EvalFromChatDraft } from './types';
import { getGroundTruthFromChat } from '../services/evalService';
import { useEvalGroundTruthForm } from './hooks/useEvalGroundTruthForm';

interface AddToEvalButtonProps {
    messages: AgenticChatMessage[];
    activeThreadId?: string;
}

export const AddToEvalButton: React.FC<AddToEvalButtonProps> = ({ messages, activeThreadId }) => {
    const [loading, setLoading] = useState(false);
    const [draft, setDraft] = useState<EvalFromChatDraft | null>(null);
    const [formOpen, setFormOpen] = useState(false);
    const groundTruthFormData = useEvalGroundTruthForm(formOpen);

    const handleSelectMessage = async (msg: {
        thread_id?: string;
        run_id?: string;
    }) => {
        setLoading(true);
        try {
            const d = await getGroundTruthFromChat(msg.thread_id!, msg.run_id!);
            setDraft(d);
            setFormOpen(true);
        } catch (err) {
            message.error(`Failed to fetch draft: ${err}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <SkillStudioAddToEvalButton
            messages={messages as SkillStudioAddToEvalMessage[]}
            activeThreadId={activeThreadId}
            loading={loading}
            onSelectMessage={handleSelectMessage}
            groundTruthForm={(
                <SkillStudioEvalGroundTruthForm
                    open={formOpen}
                    mode="from_chat"
                    initialData={draft}
                    onClose={() => {
                        setFormOpen(false);
                        setDraft(null);
                    }}
                    {...groundTruthFormData}
                />
            )}
        />
    );
};
